import { currentTimeMillis, Day, Hour, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { valueType_StandardRange } from '@app/hcs-shared';
export const mockSectionGraphResults = (varIds) => {
    const currentTime = currentTimeMillis();
    return varIds.reduce((results, varId) => {
        const variable = ModuleFE_Variable.cache.unique(varId);
        if (!variable)
            throw new MUSTNeverHappenException(`Could not get variable for id ${varId}`);
        const value = ModuleFE_Value.cache.unique(variable.valueId);
        if (!value)
            throw new MUSTNeverHappenException(`Could not get value for id ${variable.valueId}`);
        const range = value.type === valueType_StandardRange
            ? value.data.fullRange
            : [1, 100];
        const delta = range[1] - range[0];
        const getVal = () => Math.floor(Math.random() * delta);
        results[varId] = [
            { value: getVal(), timestamp: currentTime, currentVisit: true },
            { value: getVal(), timestamp: currentTime - Hour, currentVisit: true }, //Second sample is an hour ago
            { value: getVal(), timestamp: currentTime - Day, currentVisit: false }, //Third sample is a day ago
            { value: getVal(), timestamp: currentTime - (2 * Day), currentVisit: false }, //Fourth sample is 2 days ago
        ];
        return results;
    }, {});
};
//# sourceMappingURL=mock-results.js.map